import { decodeToken } from "../Components/SbSessionCheckerComponent/SbSessionChecker";

/**
 * Validates if a token exists and is not expired
 * @param {string} token - JWT access token
 * @param {string} context - Optional context string for logging (e.g., "AuthContext", "useGlobalSSE")
 * @returns {boolean} - true if token is valid and not expired
 */
export const isTokenValid = (token, context = '') => {
  const logPrefix = context ? `[${context}]` : '[TokenValidation]';
  
  if (!token) {
    console.debug(`${logPrefix} No token provided`);
    return false;
  }
  
  try {
    const decoded = decodeToken(token);
    if (!decoded || !decoded.exp) {
      console.warn(`${logPrefix} Token missing expiration claim`);
      return false;
    }
    
    // Check if token is expired (with 60 second buffer)
    const now = Math.floor(Date.now() / 1000);
    const isValid = decoded.exp > (now + 60);
    
    if (!isValid) {
      console.info(`${logPrefix} Token expired or expiring soon (exp: ${decoded.exp}, now: ${now})`);
    }
    
    return isValid;
  } catch (error) {
    console.error(`${logPrefix} Token validation error:`, error);
    return false;
  }
};
